import React, { memo } from 'react'
import { Icon } from '@iconify/react'

import { formatCapacityDate, formatCapacityHours } from '../capacity.utils'
import styles from '../ProjectCapacityDashboard.module.css'

const SUMMARY_ITEMS = [
    {
        key: 'assigned',
        label: 'Total Assigned Hours',
        icon: 'mdi:clock-outline',
        color: '#4f46e5',
        getValue: (s) => formatCapacityHours(s.totalAssignedHours),
    },
    {
        key: 'available',
        label: 'Available Hours',
        icon: 'mdi:clock-check-outline',
        color: '#22c55e',
        getValue: (s) => formatCapacityHours(s.availableHours),
    },
    {
        key: 'occupied',
        label: 'Occupied',
        icon: 'mdi:chart-donut',
        color: '#f59e0b',
        getValue: (s) => `${s.occupiedPercent}%`,
    },
    {
        key: 'projects',
        label: 'Active Projects',
        icon: 'mdi:folder-multiple-outline',
        color: '#6366f1',
        getValue: (s) => String(s.activeProjects),
    },
    {
        key: 'free',
        label: 'Estimated Available Date',
        icon: 'mdi:calendar-check-outline',
        color: '#0ea5e9',
        getValue: (s) => formatCapacityDate(s.freeFrom),
    },
]

const CapacitySummary = memo(({ summary }) => (
    <div className={styles.summaryRow}>
        {SUMMARY_ITEMS.map((item) => (
            <div key={item.key} className={styles.summaryCard}>
                <div className={styles.summaryCardTop}>
                    <span className={styles.summaryLabel}>{item.label}</span>
                    <span
                        className={styles.summaryIconWrap}
                        style={{ color: item.color }}
                    >
                        <Icon icon={item.icon} width={16} height={16} />
                    </span>
                </div>
                <div
                    className={styles.summaryValue}
                    style={{ color: item.color }}
                >
                    {item.getValue(summary)}
                </div>
            </div>
        ))}
    </div>
))

CapacitySummary.displayName = 'CapacitySummary'

export default CapacitySummary
